import {PrepareMyListForEdit, UpdateMyList, addRemoveProductToActiveList, changeCustomList, deleteMyList, getBoughtProducts,  getMyLists, getNewProducts, moveFromToInMyList, swapReplacedProductInMyList} from "../actions/productLists.js";
import {clearQuery, editQueryFilter, loadMoreSearchedProducts} from "../actions/productQuery.js";
import {setDropDown, setModal} from "../../common/actions/modal.js";

import EditMyListPage from "../components/order/EditMyListPage.jsx";
import {connect} from "react-redux";
import {createBoundFunction} from "../../common/util/reselect.js";
import {createFlowControl} from "../../common/util/flowControl";
import {createLocalization} from "../../common/util/localization.jsx";
import {scssVariables} from "../../common/util/config.jsx";
import {setOrderProductView} from "../actions/order.js";
import {withRouter} from "react-router-dom";

const mapStateToProps = () => {
    const flowControl = createFlowControl();
    return (state, ownProps) => ({
        startView: ownProps.match.params.view || "card",
        listId: parseInt(ownProps.match.params.listId),
        localization: createLocalization(state),
        productView: state.order.productView,
        deviceType: state.view.deviceType,
        flowControl: flowControl,
        productQuery: state.productQuery,
        editingList: state.productLists.customLists.find( (element) => element.myListId==ownProps.match.params.listId) || {},
        productImage: state.productImage,
        width: state.view.innerWidth,
        deliveryDates: state.delivery.dates.deliveryDates || [],
        height: state.view.innerHeight-parseInt(scssVariables.menuHeight),
        productLists: state.productLists,
    });
};

const mapDispatchToProps = {
    setOrderProductView,
    loadMoreSearchedProducts,
    editQueryFilter,
    addRemoveProductToActiveList,
    getMyLists,
    UpdateMyList,
    deleteMyList,
    changeCustomList,
    moveFromToInMyList,
    swapReplacedProductInMyList,
    PrepareMyListForEdit,
    setModal,
    setDropDown,
    getBoughtProducts,
    getNewProducts,
    clearQuery,
};

const myAddRemoveProductToActiveList = createBoundFunction();
const myLoadMoreSearchedProducts = createBoundFunction();
const myEditQueryFilter = createBoundFunction();
const myUpdateMyList = createBoundFunction();
const myDeleteMyList = createBoundFunction();
const myChangeCustomList = createBoundFunction();
const mymoveFromToInMyList = createBoundFunction();
const myswapReplacedProductInMyList = createBoundFunction();

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
    ...stateProps,
    ...dispatchProps,
    ...ownProps,
    addRemoveProductToActiveList: myAddRemoveProductToActiveList((product, qty) => dispatchProps.addRemoveProductToActiveList(stateProps.listId, product, qty)),
    moveFromToInMyList: mymoveFromToInMyList((index1, index2) => dispatchProps.moveFromToInMyList(stateProps.listId, index1, index2)),
    swapReplacedProductInMyList: myswapReplacedProductInMyList((replacedProductId, replacementProductId) => dispatchProps.swapReplacedProductInMyList(stateProps.listId, replacedProductId, replacementProductId)),
    loadMoreSearchedProducts: myLoadMoreSearchedProducts((noOfProducts) => dispatchProps.loadMoreSearchedProducts(stateProps.productQuery, stateProps.productImage, noOfProducts)),
    editQueryFilter: myEditQueryFilter( (change) => dispatchProps.editQueryFilter(stateProps.productQuery, stateProps.productImage, change, 
        myLoadMoreSearchedProducts((noOfProducts) => dispatchProps.loadMoreSearchedProducts(stateProps.productQuery, stateProps.productImage, noOfProducts))
    )),
    UpdateMyList: myUpdateMyList(() => dispatchProps.UpdateMyList(stateProps.editingList, ownProps.history)),
    deleteMyList: myDeleteMyList(() => dispatchProps.deleteMyList(stateProps.editingList, ownProps.history)),
    changeCustomList: myChangeCustomList((change) => dispatchProps.changeCustomList(stateProps.listId, change)),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps, mergeProps)(EditMyListPage));